<div class="modal-header">
	<button type="button" class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">{{TR "Tabelle konfigurieren"}}</h4>
</div>
<div class="modal-body">
	{{FIELDS_LIST_BOX selected 'col_multi_select' 'columns' this}}
</div>
<div class="modal-footer">
	<button id="ct-cancel" type="button" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
	<a class="btn btn-primary" id="js-save">{{TR "Speichern"}}</a>
</div>
